export enum enumInsuranceState {
  QUOTE,
  ACTIVE,
  EXPIRED,
  CUSTOM,
}
